import Constants from '../../constants/constants';
import DomainUrlRedirect from './domainUrlRedirect';

const AdminDashboardRedirect = () => {
  return <DomainUrlRedirect url={Constants.BACKEND_URL} pathname={'admin'} authParamName={'token'} />; // DONE: passing a name not avariable
};

export default AdminDashboardRedirect;
